const s = { fill: 'currentColor', display: 'block' };

export const PlayIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M7 5v14l12-7L7 5z" />
  </svg>
);

export const PauseIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M6 5h4v14H6zM14 5h4v14h-4z" />
  </svg>
);

export const PrevIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M6 5h2v14H6zM20 5v14L9 12l11-7z" />
  </svg>
);

export const NextIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M16 5h2v14h-2zM4 5v14l11-7L4 5z" />
  </svg>
);

export const HeartIcon = ({ size = 22, filled = false }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    {filled ? (
      <path d="M12 21s-7-4.5-9.5-9A5.5 5.5 0 0 1 12 6a5.5 5.5 0 0 1 9.5 6C19 16.5 12 21 12 21z" />
    ) : (
      <path
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        d="M12 20.5s-6.4-4.15-8.7-8.35a4.7 4.7 0 0 1 8.7-3.05 4.7 4.7 0 0 1 8.7 3.05C18.4 16.35 12 20.5 12 20.5z"
      />
    )}
  </svg>
);

export const VolumeIcon = ({ size = 22, level = 1 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M3 10v4h4l5 4V6L7 10H3z" />
    {level > 0.05 && <path fill="none" stroke="currentColor" strokeWidth="1.8" d="M15.5 8.5c1.6 1.6 1.6 5.4 0 7" />}
    {level > 0.5 && <path fill="none" stroke="currentColor" strokeWidth="1.8" d="M18 6c3 3 3 9 0 12" />}
  </svg>
);

export const MuteIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M3 10v4h4l5 4V6L7 10H3z" />
    <path fill="none" stroke="currentColor" strokeWidth="1.8" d="M16 9l5 6M21 9l-5 6" />
  </svg>
);

export const HomeIcon = ({ size = 20 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M12 3l9 8h-3v9h-4v-6h-4v6H6v-9H3l9-8z" />
  </svg>
);

export const MenuIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M4 6h16M4 12h16M4 18h16" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const CloseIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M5 5l14 14M19 5L5 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />
  </svg>
);

export const ChevronDownIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path d="M6 9l6 6 6-6" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
  </svg>
);

export const DownloadIcon = ({ size = 22 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" style={s} aria-hidden="true">
    <path fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" d="M12 3v13M7 11l5 5 5-5M5 20h14" />
  </svg>
);
